export const getCockpitFiscalYearLabel = (fYear: number) =>
  `FY${String(fYear).slice(-2).padStart(2, '0')}`
